import { render, staticRenderFns } from "./OfferTabs.vue?vue&type=template&id=b30a5364&"
import script from "./OfferTabs.vue?vue&type=script&lang=js&"
export * from "./OfferTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports